import Controller, { inject as controller } from "@ember/controller";
export default class LoginPageController extends Controller {
  static #_ = (() => dt7948.g(this.prototype, "application", [controller]))();
  #application = (() => (dt7948.i(this, "application"), void 0))();
}